import type { FooterAssets } from "./types";

export function resolveLogoUrl(
  assetsBase: string,
  theme: "light" | "dark",
  assets?: FooterAssets
): string {
  if (assets?.logo) {
    return assets.logo;
  }
  if (theme === "dark" && assets?.logoDark) {
    return assets.logoDark;
  }
  if (theme === "light" && assets?.logoLight) {
    return assets.logoLight;
  }
  if (theme === "dark") {
    return `${assetsBase}/logo-pandorium-inverse.png`;
  }
  return `${assetsBase}/logo-pandorium.png`;
}

export function resolveIconUrl(
  assetsBase: string,
  clientsBase: string,
  assets?: FooterAssets,
  clientId?: string
): string {
  if (assets?.icon) {
    return assets.icon;
  }
  if (clientId) {
    return `${clientsBase}/${clientId}/icon.png`;
  }
  return `${assetsBase}/logo-icon.png`;
}

export function resolveAvatarUrl(
  assetsBase: string,
  clientsBase: string,
  assets?: FooterAssets,
  clientId?: string
): string {
  if (assets?.avatar) {
    return assets.avatar;
  }
  if (clientId) {
    return `${clientsBase}/${clientId}/avatar.png`;
  }
  return `${assetsBase}/logo-icon.png`;
}

export function resolveClientAssetUrl(
  clientsBase: string,
  clientId: string,
  filename: string
): string {
  return `${clientsBase}/${clientId}/${filename}`;
}
